module.exports = __webpack_public_path__ + "img/avion_naranjo.76e70922.png";